<template>
  <base-select
    v-model="proxyValue"
    v-paste="'input'"
    :options="options"
    v-bind="proxyProps"
    v-on="$listeners"
    @paste="onPaste"
  />
</template>
<script>
import paste from '@/directive/paste'
const INNER_PARSER = {
  string: (pasteText) => pasteText.trim(),
  /**
   * @param {string} pasteText
   * @returns {String}
   * @description 从 Excel Sheet 中复制的一整列数据（不包含 header row）到此组件的输入框内, 识别粘贴的内容, 替换所有的回车换行并逗号分隔
   */
  'sheet-column': (pasteText, splitor) => {
    let result = pasteText
    try {
      // result = string.replace(/\r\n/g, ' ')
      // result = string.replace(/\r/g, ' ')
      // result = string.replace(/\n/g, ' ')
      result = pasteText
        .trim()
        .replace(/\r\n/g, splitor)
        .replace(/\n/g, splitor)
    } catch (e) {
      console.error(e)
    }
    return result
  }
}
export default {
  name: 'PasteSelect',
  directives: { paste },
  model: {
    event: 'input'
  },
  props: {
    value: {
      type: [String, Number, Boolean, Array],
      default: null
    },
    type: {
      type: String,
      default: 'sheet-column'
    },
    splitor: {
      type: String,
      default: ','
    },
    parser: {
      type: Function,
      default: null
    },
    limit: {
      type: Number,
      default: 400
    },
    filterSpecialCharacters: {
      type: Boolean,
      default: true
    },
    hasMessageOnExceedLimit: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  computed: {
    proxyValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    options() {
      return Array.isArray(this.proxyValue)
        ? this.proxyValue.map((v) => ({ label: v, value: v }))
        : []
    },
    proxyProps() {
      const {
        allowCreate, // eslint-disable-line no-unused-vars
        remote, // eslint-disable-line no-unused-vars
        remoteMethod, // eslint-disable-line no-unused-vars
        multiple = true, // eslint-disable-line no-unused-vars
        collapseTags = true,
        placeholder = '请粘贴数据',
        ...rest
      } = this.$attrs

      return {
        collapseTags,
        placeholder,
        multiple,
        ...rest,
        allowCreate: true,
        filterable: true,
        remote: false,
        remoteMethod: undefined
      }
    },
    /**
     * @returns {Function}
     */
    innerParser() {
      const parser = INNER_PARSER[this.type]
      if (typeof parser === 'undefined') {
        console.error('invalid type', this.type)
      }

      return this.parser ?? INNER_PARSER[this.type] ?? INNER_PARSER['string']
    }
  },
  methods: {
    onPaste(pasteText) {
      // 解析
      const parsedStr = this.innerParser(pasteText, this.splitor) ?? '' // eslint-disable-line vue/no-use-computed-property-like-method
      console.log('content:', parsedStr)

      if (!parsedStr) {
        return void console.warn('Empty copied content')
      }

      // 去空 + 去重
      const parsedArr = parsedStr
        .split(',')
        .map((item) => item.trim())
        .filter((v) => !!v.trim())
      console.log('parsed array:', parsedArr)
      let uniqueArr = [...new Set(parsedArr)]
      // 多次分步处理特殊情况
      if (this.filterSpecialCharacters) {
        // 去除元素内空格 特殊中文逗号
        uniqueArr = uniqueArr.map((element) => element.replace(/\s+|，|,/g, ''))
        // 剔除特殊场景回车导致的  " "
        uniqueArr = uniqueArr.reduce((acc, current, index, arr) => {
          // 检查当前元素是否以引号开头，并且下一个元素以引号结尾
          if (
            current.startsWith('"') &&
            arr[index + 1] &&
            arr[index + 1].endsWith('"')
          ) {
            acc.push(current.slice(1) + arr[index + 1].slice(0, -1))
            index++
          } else {
            if (current.endsWith('"')) {
              acc.push('')
            } else {
              acc.push(current)
            }
          }
          return acc
        }, [])
        uniqueArr = uniqueArr.filter((item) => item !== '')
      }

      console.log('unique array:', uniqueArr)
      if (parsedArr.length !== uniqueArr.length) {
        console.warn('Duplicate in copied content, removed')
      }

      // 多选时，限制个数
      this.proxyValue = uniqueArr.slice(0, this.limit)

      if (this.hasMessageOnExceedLimit && uniqueArr.length > this.limit) {
        this.$message.info(`只能查询到前${this.limit}条`)
      }

      console.log('value:', this.proxyValue)
    }
  }
}
</script>
